import { Box, Dialog, IconButton, Slide, Typography } from '@mui/material';
import React, { forwardRef } from 'react';
import CloseIcon from "@mui/icons-material/Close";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
});

export default function MarketplaceAllergyModal({
  open,
  selectedItem,
  handleClose
}) {

  const nutrientFields = {
    "kCal": { label: "Calories", unit: "kcal" },
    "fat": { label: "Fat", unit: "g" },
    "carbohydrates": { label: "Carbs", unit: "g" },
    "protein": { label: "Protein", unit: "g" }
  };

  return (
    <Dialog open={open} TransitionComponent={Transition}>
      <Box className="customScrollbar"
        sx={{
          backgroundColor: "#f4f9f9",
          border: "2px solid #737373",
          borderRadius: ".5rem",
          overflowY: "auto",
          width: "425px"
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            flex: "1 0 100%",
            marginBottom: "1rem"
          }}>
          <Typography
            variant="h5"
            fontWeight="bold"
            sx={{ padding: "1rem 0 0 1.5rem" }}>
            Nutrition
          </Typography>
          <IconButton
            sx={{
              marginRight: "1rem",
              marginLeft: "auto",
              marginTop: "1rem",
              alignSelf: "flex-start",
              color: "var(--redColor)",
              height: "2rem",
              width: "2rem",
            }}
            onClick={() => handleClose()}
            aria-label="Close">
            <CloseIcon sx={{ fontSize: "2rem" }}/>
          </IconButton>
        </Box>

        <Box px={3} pb={2}>
          <Box
            backgroundColor="#e6e6e6"
            paddingLeft={1}
            paddingY={1}
          >
            <Typography
              fontWeight="bold"
              variant="h6"
            >
              {selectedItem.name}
            </Typography>
          </Box>
          {Object.entries(nutrientFields).map(([key, { label, unit }], index, arr) => (
            <Box
              key={key}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                p: 1,
                borderBottom: index < arr.length - 1 ? "2px solid #d0d0d0" : "none",
              }}
            >
              <Typography variant="body1">{label}</Typography>
              <Typography variant="body1">
                {selectedItem?.[key] ?? 0} {unit}
              </Typography>
            </Box>
          ))}
        </Box>

        <Box px={3} pb={3}>
          <Typography
            fontSize=".875rem"
            fontStyle="italic"
            pl={1}
          >
            <strong>Allergies:</strong> {selectedItem?.allergies?.length 
            ? selectedItem.allergies.map((a) => a.allergyFoodName).join(", ")
              : "None"}
          </Typography>
          {!!selectedItem?.relevantResidentAllergies?.length && (
            <Typography
              fontSize=".875rem"
              fontStyle="italic"
              marginTop=".25rem"
              pl={1}
            >
              <strong>Resident Allergies:</strong> {selectedItem.relevantResidentAllergies}
            </Typography>
          )}
        </Box>
      </Box>
    </Dialog>
  );
}